/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { Dialog } from "../../../dialogs/Dialog";
import { CreateDirectoryDialogComponent } from "./CreateDirectoryDialogComponent";
import { IFieldConfig } from "../../../ui/hooks/useFieldGroup";

export interface CreateDirectoryDialog_Params {
	defaultValue?: string;
	getValidators?: (opts?: { basePath?: string }) => IFieldConfig<string>["validators"];
}

export interface CreateDirectoryDialog_Result {
	basePath: string;
	name: string;
}

export class CreateDirectoryDialog extends Dialog<
	CreateDirectoryDialog_Params,
	CreateDirectoryDialog_Result
> {
	public getComponent(): typeof CreateDirectoryDialogComponent {
		return CreateDirectoryDialogComponent;
	}
}
